import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { ConversionSubNavWrapper } from "./StyledComponents";
import ConversionSubNav from "app/pages/conversion/ConversionSubNav";
import type { FC } from "react";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import { ErrorBoundary } from "react-error-boundary";

export const ConversionRootContainer: FC<{ shouldLogErrorFallback: boolean }> = ({ shouldLogErrorFallback }) => {
    const autoScrollRef = useAutoScrollTop();
    const { state: currentState, params } = useCurrentStateAndParams();

    return (
        <ErrorBoundary
            FallbackComponent={(props) => (
                <ErrorFallback
                    {...props}
                    shouldLogErrorFallback={shouldLogErrorFallback}
                />
            )}
            resetKeys={[currentState, params]}
        >
            <div className="sw-layout-module-inner">
                <ConversionSubNavWrapper className="u-flex-row u-flex-column">
                    <ConversionSubNav className="sw-layout-subnav disable-shadow" />
                    <div
                        ref={autoScrollRef}
                        className="sw-layout-scrollable-element sw-layout-research disable-top-padding use-sticky-css-rendering fadeIn"
                    >
                        <UIView />
                    </div>
                </ConversionSubNavWrapper>
            </div>
        </ErrorBoundary>
    );
};
